import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import Moment from 'react-moment';
import { Alert, Button, Card, CardBody, Spinner, Table } from 'reactstrap';
import { language } from 'lib/translate';
import formatAmount from 'lib/formatAmount.js';
// import t, { language } from 'lib/translate';
import { withRouter } from 'containers/withRouter';
import {
  providesInboxedBankingDocuments,
  consumesInboxedBankingDocuments,
} from 'contexts/InboxedBankingDocumentsContext';
import './BankingDocumentsInbox.scss';

class BankingDocumentsInbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deletingId: null,
      processing: false,
      processResult: null,
    };
  }

  formatSource(source) {
    try {
      return JSON.stringify(JSON.parse(source), null, 4);
    } catch {
      return source;
    }
  }

  deleteDocument(doc) {
    this.setState({ deletingId: doc.id });

    this.props.remoteInboxedBankingDocuments.api.delete(doc, () => {
      this.setState({ deletingId: null });
    });
  }

  async processDocuments() {
    const dossierId = this.props.match.params.dossierId;

    this.setState({ processing: true, processResult: null });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/dossiers/${dossierId}/inboxed-banking-documents/process`
      );
      this.setState({ processResult: response.data });
      this.props.remoteInboxedBankingDocuments.api.fetch();

      if (response.data.generatedDocuments.length > 0) {
        this.props.refreshBankingDocuments();
      }
    } finally {
      this.setState({ processing: false });
    }
  }

  renderProcessResult() {
    const { processResult } = this.state;

    if (!processResult) {
      return null;
    }

    const { dossierId } = this.props.match.params;

    return (
      <Alert color="info" className="mb-4">
        <p>Generated documents: {processResult.generatedDocuments.length}</p>
        {processResult.generatedDocuments.length > 0 && (
          <ul>
            {processResult.generatedDocuments.map((doc) => (
              <li key={doc.id}>
                <a href={`/dossier/${dossierId}/${doc.periodId}/banking-documents/${doc.id}`}>
                  Banking document {doc.id}
                </a>
              </li>
            ))}
          </ul>
        )}
        <p>Missing bank account matches (no IBAN match): {processResult.numMissingAccountMatches}</p>
        <p className="mb-0">Matched banking transactions: {processResult.numMatchedTransactions}</p>
      </Alert>
    );
  }

  renderInbox() {
    if (this.props.remoteInboxedBankingDocuments.isLoading) {
      return <Spinner />;
    }

    const retryButton = (
      <div className="mb-4">
        {this.state.processing ? (
          <Spinner />
        ) : (
          <Button onClick={() => this.processDocuments()} disabled={this.state.processing}>
            Rerun import &amp; matching
          </Button>
        )}
      </div>
    );

    if (this.props.inboxedBankingDocuments.length === 0) {
      return (
        <>
          {retryButton}
          <em>empty</em>
        </>
      );
    }

    const docs = this.props.inboxedBankingDocuments.map((doc) => (
      <Card className="mb-4" key={doc.id}>
        <CardBody>
          <div className="mb-4">
            {this.state.deletingId === doc.id ? (
              <Spinner />
            ) : (
              <Button color="warning" onClick={() => this.deleteDocument(doc)} disabled={!!this.state.deletingId}>
                Delete
              </Button>
            )}
          </div>
          <div className="d-flex">
            <div className="mr-4">
              <h3 className="mb-4">Import</h3>
              <dl>
                <dt>id</dt>
                <dd>{doc.id}</dd>
                <dt>iban</dt>
                <dd>{doc.iban}</dd>
                <dt>dateFrom</dt>
                <dd>
                  <Moment date={doc.dateFrom} format={'DD.MM.YYYY'} />
                </dd>
                <dt>dateTo</dt>
                <dd>
                  <Moment date={doc.dateTo} format={'DD.MM.YYYY'} />
                </dd>
                <dt>startingBalance</dt>
                <dd>{formatAmount(doc.startingBalance)}</dd>
                <dt>endBalance</dt>
                <dd>{formatAmount(doc.endBalance)}</dd>
                <dt>currency</dt>
                <dd>{doc.currency}</dd>
                <dt>createdAt</dt>
                <dd title={moment(doc.createdAt).format('DD.MM.YYYY')}>
                  <Moment fromNow locale={language} date={doc.createdAt}></Moment>
                </dd>
              </dl>
            </div>
            <div className="flex-fill">
              <h3 className="mb-4">Transactions ({doc.transactions.length})</h3>
              <Table>
                <thead>
                  <tr>
                    <th>id</th>
                    <th>valueDate</th>
                    <th>bookingDate</th>
                    <th>description</th>
                    <th>amount</th>
                    <th>currency</th>
                  </tr>
                </thead>
                <tbody>
                  {doc.transactions.map((t) => (
                    <tr key={t.id}>
                      <td>{t.id}</td>
                      <td>{moment(t.valueDate).format('DD.MM.YYYY')}</td>
                      <td>{moment(t.bookingDate).format('DD.MM.YYYY')}</td>
                      <td className="col-description">{t.description}</td>
                      <td>{formatAmount(t.amount)}</td>
                      <td>{t.currency}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
          <hr />
          <details>
            <summary>source</summary>
            <pre>{this.formatSource(doc.source)}</pre>
          </details>
        </CardBody>
      </Card>
    ));

    return (
      <>
        {retryButton}
        {this.state.processing ? null : docs}
      </>
    );
  }

  render() {
    return (
      <div className="BankingDocumentsInbox m-4 pt-4">
        <h2 className="mb-4">Pending bLink imports</h2>
        {this.renderProcessResult()}
        {this.renderInbox()}
      </div>
    );
  }
}

BankingDocumentsInbox.propTypes = {
  inboxedBankingDocuments: PropTypes.arrayOf(PropTypes.object).isRequired,
  remoteInboxedBankingDocuments: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  refreshBankingDocuments: PropTypes.func.isRequired,
};

export default providesInboxedBankingDocuments(consumesInboxedBankingDocuments(withRouter(BankingDocumentsInbox)));
